import React from "react";
import food from "../../img/about/food.png";
import "./Gastronomy.css";

function Gastronomy() {
  return (
    <div className="Gastronomy">
    
    <div className="Gastronomy__mobile__img">
    <img src={food} alt="Luxury villa with sea view in Costa Blanca, Spain" />
    </div>
   
      
      
      <div className="Gastronomy__txt">
        <h1>Gastronomy</h1>
        <p>
          Embark on a culinary journey through Costa Blanca's gastronomic
          delights. Indulge in tantalizing seafood paellas freshly prepared with
          the finest local ingredients or savor authentic tapas bursting with
          Mediterranean flavors.
          <br />
          
          <br />
          From quaint seaside taverns to Michelin-starred restaurants, the
          region's culinary scene promises a feast for the senses that will
          leave a lasting impression on even the most discerning palate.
        </p>
      </div>
      <div className="Gastronomy__img">
        <img src={food} alt="Luxury villa with sea view in Costa Blanca, Spain" />
      </div>
    </div>
  );
}

export default Gastronomy;
